
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h20v22H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","fill":"none","stroke":"#303030","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M1 5h18M17 5v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5m3 0V3a2 2 0 012-2h4a2 2 0 012 2v2M8 10v6M12 10v6"}})])])
          )
        }
      }
    